import SectionTitle from 'components/Globals/SectionTitle';
import { PostContentItem } from 'components/ContentItem';
import Slider from 'react-slick';
import NextArrow from 'components/Arrows/NextArrow';
import PrevArrow from 'components/Arrows/PrevArrow';
import type { ArticlePreview } from 'interfaces/content/articles/Articles';
import * as S from './LatestStoriesStyles';
import { useState } from 'react';
import SECTION_PAGE_TEST_IDS from 'constants/testsIds/sectionPage';

interface LatestStoriesProps {
  title: string;
  stories: ArticlePreview[];
  dataCy: string;
}

const LatestStories = ({ title, stories, dataCy }: LatestStoriesProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const sliderSettings = {
    infinite: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (_oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          rows: 1,
          slidesToShow: 1.2,
        },
      },
    ],
    slidesToShow: 4,
  };

  const trackingData = {
    contentPlacementCD: 'related content',
    eventCategory: 'article',
  };

  return (
    <S.Wrapper>
      <SectionTitle
        text={title}
        titleDataCy={SECTION_PAGE_TEST_IDS.LATEST_STORIES_TITLE}
        tag='h2'
        variant='border'
        className='title'
      />
      <S.SliderWrapper data-cy={dataCy}>
        <Slider {...sliderSettings}>
          {stories?.map((story, index) => {
            const isHiddenSlide = index < currentSlide || index >= currentSlide + 4;

            const postContentItemProps = {
              authors: story.authors,
              date: story.date,
              eyebrowSectionLabel: story.eyebrowSectionLabel,
              eyebrowSectionLink: story.eyebrowSectionLink,
              image: story.image,
              title: story.title,
              titleLink: story.externalUrl || story.titleLink,
            };

            return (
              <div key={story.databaseId ?? story.title}>
                <PostContentItem
                  as='div'
                  {...postContentItemProps}
                  className='post-list'
                  trackingData={{
                    ...trackingData,
                    eventAction: story.eyebrowSectionLabel,
                    eventLabel: story.title,
                  }}
                  isHiddenSlide={isHiddenSlide}
                />
              </div>
            );
          })}
        </Slider>
      </S.SliderWrapper>
    </S.Wrapper>
  );
};

export default LatestStories;
